import { Injectable } from "@angular/core";

import { MapperInterface } from "../mapper-inteface";

import { DocumentoGescorDTO } from "@app/shared/dto/gescor/documeto-gescorDTO";






import { DocumentoVO } from "@app/shared/vo/documentoVO";

@Injectable({
  providedIn: "root",
})
export class MapperDocumentoToDocumentoGescor
  implements MapperInterface<DocumentoGescorDTO, DocumentoVO> {
  constructor(
  ) { }
  convertVoToDto(vo: DocumentoVO): DocumentoGescorDTO {
    if (vo != null) {
      const dto = new DocumentoGescorDTO();
      dto.hash = vo.hash;
      dto.nome = vo.nome;
      dto.id = vo.idRepository;
      dto.idRepository = vo.idRepository;
      return dto;
    } else {
      return null;
    }
  }

  convertDtoToVo(dto: DocumentoGescorDTO): DocumentoVO {
    if (dto != null) {
      const vo = new DocumentoVO();
      vo.hash = dto.hash;
      vo.nome = dto.nome;
      vo.idRepository = dto.id;
      return vo;
    } else {
      return null;
    }
  }
  convertListVoToDto(e: DocumentoVO[]): DocumentoGescorDTO[] {
    if (e != null) {
      return e.map((vo) => this.convertVoToDto(vo));
    } else {
      return null;
    }
  }
  convertListDtoToVo(t: DocumentoGescorDTO[]): DocumentoVO[] {
    if (t != null) {
      return t.map((vo) => this.convertDtoToVo(vo));
    } else {
      return null;
    }
  }
}
